import { Routes, Route, Navigate } from 'react-router-dom';
import { useStore } from './store/useStore';
import AppShell from './components/AppShell';
import Dashboard from './pages/Dashboard';
import Customers from './pages/Customers';
import AdminEntitlements from './pages/Entitlements';
import Servers from './pages/Servers';
import FleetMap from './pages/FleetMap';
import Login from './pages/Login';

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const isAuthenticated = useStore((state) => state.auth.isAuthenticated);

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
}

export default function App() {
  const isAuthenticated = useStore((state) => state.auth.isAuthenticated);

  return (
    <Routes>
      <Route
        path="/login"
        element={isAuthenticated ? <Navigate to="/" replace /> : <Login />}
      />
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <AppShell />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="customers" element={<Customers />} />
        <Route path="admin-entitlements" element={<AdminEntitlements />} />
        <Route path="servers" element={<Servers />} />
        <Route path="map" element={<FleetMap />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
